// core
import React, { CSSProperties } from "react";

// components
import { IconSet, IconSetIds } from "./IconMap";
import cx from "classnames";
import styles from "./Icon.module.scss";

export type IconSizes =
    | "none"
    | "full"
    | "4xl"
    | "3xl"
    | "2xl"
    | "xl"
    | "l"
    | "ml"
    | "m"
    | "s"
    | "xs";
interface IIconProps {
    id: IconSetIds;
    height?: string;
    width?: string;
    style?: CSSProperties;
    className?: string;
    size?: IconSizes;
    alt?: string;
}

const Icon = React.forwardRef<HTMLImageElement, IIconProps>((props, ref) => {
    const { id, height, width, style, className, size, alt } = props;

    return (
        <img
            src={IconSet[id]}
            style={{
                userSelect: "none",
                ...style
            }}
            alt={alt || "img"}
            height={height}
            width={width}
            draggable="false"
            className={cx({
                [className]: !!className,
                [styles[`icon--size-${size}`]]: !!size
            })}
            ref={ref}
        />
    );
});

Icon.displayName = "Icon";

export default Icon;
